import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

export type BlockParameters = {
  action: string;
  location: {
    pathname: string;
    hash: string;
    search: string;
    state: null | unknown;
    key: string;
  };
  retry: VoidFunction;
};
/**
 * The library has a bug with types. The "block" method is not defined in the "navigator" object, but it exists.
 * @remark [Documentation](https://ui.dev/react-router-preventing-transitions)
 * @param blocker - callback on blocked navigation
 * @param when - parameter to blocking navigation
 * @example
 * useBlocker((location) => {
 *   console.log("Navigation is blocked!", location)
 * }, isDirty);
 */
export function useBlocker(blocker: (val: BlockParameters) => void, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;

    //@ts-ignore
    const unblock = navigator.block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        },
      };

      blocker(autoUnblockingTx);
    });

    return unblock;
  }, [navigator, blocker, when]);
}
